import Api from "./Api.js";
import qs from "qs";
import { getBaseUrl } from "@/api/ApiHelper";

const resource = "/customers";

export default {
  get(filters) {
    Object.keys(filters).forEach(
      (key) => filters[key] == null && delete filters[key],
    );
    return Api.get(`${resource}`, {
      params: filters,
      paramsSerializer: (filters) => {
        return qs.stringify(filters, {
          arrayFormat: "brackets",
          encode: false,
        });
      },
    });
  },

  getCustomer(customerId) {
    return Api.get(`${resource}/${customerId}`);
  },

  getUnsubscribe(customerId) {
    return Api.get(`${resource}/${customerId}/unsubscribe`);
  },

  patchUnsubscribe(customerId, data) {
    return Api.patch(`${resource}/${customerId}/unsubscribe`, data);
  },

  getEmailTimeline(customerId) {
    return Api.get(`${resource}/${customerId}/email/timeline`);
  },

  getZendeskTickets(customerId) {
    return Api.get(`${resource}/${customerId}/zendesk/tickets`);
  },

  getShopifyDiscounts(customerId) {
    return Api.get(`${resource}/${customerId}/shopify-discounts`, {
      baseURL: getBaseUrl("v2"),
    });
  },

  sendDiscountEmail(customerId, discountId, data = {}) {
    return Api.post(
      `${resource}/${customerId}/shopify-discounts/${discountId}/resend-email`,
      data,
      {
        baseURL: getBaseUrl("v2"),
      },
    );
  },
};
